// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.criteria.RentalManagerUserPropertyCriteriaWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { ListingAlias, UserPropertyCriteriaGetResponseWebDto, UserPropertyCriteriaSetRequestWebDto } from '../..';

interface GetParams {
  listingAlias: ListingAlias;
}
interface SetParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyCriteriaWebApiHandler_get_Path = '/api/web/v1/users/properties/criteria/get';

/**
 * Get criteria for a listing
 */
export const RentalManagerUserPropertyCriteriaWebApiHandler_get = (
  getParams: GetParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetParams, never, UserPropertyCriteriaGetResponseWebDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyCriteriaWebApiHandler_get_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertyCriteriaWebApiHandler_set_Path = '/api/web/v1/users/properties/criteria/set';

/**
 * Set criteria for a listing
 */
export const RentalManagerUserPropertyCriteriaWebApiHandler_set = (
  getParams: SetParams,
  postData: Array<UserPropertyCriteriaSetRequestWebDto>,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<SetParams, Array<UserPropertyCriteriaSetRequestWebDto>, void>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyCriteriaWebApiHandler_set_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};
